// extracted by mini-css-extract-plugin
export default {"root":"style_root__ReZ5J","pageTitle":"style_pageTitle__x4ubv","pageSubtitle":"style_pageSubtitle__YYrt+"};